import React, { useEffect, useMemo, useState } from "react";
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import { useParams } from "react-router-dom";

const baseUrl = getApiBaseUrl();

const CastCrew = ({ url }) => {
    const [data, setData] = useState({})
    const { id } = useParams()
    const apiBase = baseUrl || url || '';

    const fetchData = async () => {
        try {
            const response = await fetch(`${apiBase}/product/getsingleproduct/${id}`);
            const res = await response.json();
            console.log("PRODUCT:", res);
            if (!response.ok) {
                console.error("Product fetch failed:", response.status, res);
                setData({});
                return;
            }
            setData(res || {});
        } catch (error) {
            console.error(error);
            setData({});
        }
    };

    useEffect(() => {
        if (id) fetchData();
    }, [id]);

    // ✅ PARSE CASTLIST SAFELY
    const cast = useMemo(() => {
        if (!data.castlist) return [];
        try {
            return JSON.parse(data.castlist);
        } catch (err) {
            console.error("Invalid castlist JSON:", err);
            return [];
        }
    }, [data]);

    const grouped = useMemo(() => {
        return cast.reduce((acc, item) => {
            if (!acc[item.character]) acc[item.character] = [];
            acc[item.character].push(item);
            return acc;
        }, {});
    }, [cast]);

    return (
        <div className="cstlist-main">

            {/* Header */}
            <div
                className="cstlist-header"
                style={{
                    backgroundImage: data.product_image ? `linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0.5)), url(${apiBase}/${data.product_image})` : undefined,
                }}
            >
                <img
                    src={data.product_image ? `${apiBase}/${data.product_image}` : ''}
                    className="cstlist-poster"
                    alt="poster"
                />

                <div>
                    <h1 className="cstlist-title">{data.product_name}</h1>
                    <div
                        className="description-portfolio"
                        style={{ color: "white" }}
                        dangerouslySetInnerHTML={{
                            __html: `<div style="color:white">${data.description || ''}</div>`
                        }}
                    />

                    <h2 className="cstlist-subtitle">Full Cast & Crew</h2>
                </div>
            </div>

            {/* Jump Links */}
            <div className="cstlist-jump-section">
                <div className="cstlist-jump-label">Jump to</div>
                <div className="cstlist-jump-links">
                    {Object.keys(grouped).map((role, idx) => (
                        <a key={idx} href={`#${role}`} className="cstlist-jump-link">
                            {role}
                        </a>
                    ))}
                </div>
            </div>

            <hr className="cstlist-divider" />

            {/* Cast Sections */}
            <div className="cstlist-body">
                {Object.keys(grouped).map((role, index) => (
                    <div key={index} id={role} className="cstlist-section">
                        <div className="cstlist-section-header">
                            <span className="cstlist-section-line"></span>
                            <h2 className="cstlist-section-title">{role}</h2>
                        </div>

                        <div>
                            {grouped[role].map((person) => (
                                <div key={person.id} className="cstlist-card">
                                    <span className="cstlist-name">{person.name}</span>
                                    <span className="cstlist-role">{person.character}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default CastCrew;
